module.exports = __webpack_public_path__ + "img/77c6b5f2-6e80-45d8-8d32-5de2d7f38769.d113717d.svg";